<p-panel>
    <div class="d-flex w-100 justify-content-between">
      <h4>{{'Datos de la tarea'}}</h4>
      <button class="btn btn-primary" (click)="showDialogUploadFile = true">{{ optionsUploadFile.uploaded ? 'Ver Archivo' : 'Subir Archivo' }}</button>
    </div>
    <div class="row">
      <div class="mb-5 col-sm-12">
        <app-form-builder
          [model]="model"
          [distributionColumns]="3"
          [fields]="formFields"
          (formChanges)="formChanges($event)">
        </app-form-builder>
      </div>
    </div>
    <div>
      <h4 class="col-sm">Cultivo Arroz </h4>
      <div class="mb-5 col-sm-12">
        <app-form-builder
          [model]="model"
          [distributionColumns]="4"
          [fields]="formFieldsArroz"
          (formChanges)="formChanges($event)">
        </app-form-builder>
      </div>
      <div *ngIf="model.control_mecanico_vn ?? false" class="mb-5 col-sm-12">
        <h4>Control mecánico de la vegetación natural Palustre próxima a cursos de Agua</h4>
        <app-form-builder
          [model]="model"
          [distributionColumns]="4"
          [fields]="formFieldsPalustr"
          (formChanges)="formChanges($event)">
        </app-form-builder>
      </div>
      <div class="mb-5 col-sm-12">
        <h4>Control de Malas Hierbas en época de no cultivo</h4>
        <app-form-builder
          [model]="model"
          [distributionColumns]="4"
          [fields]="formFieldsMalasHierbas"
          (formChanges)="formChanges($event)">
        </app-form-builder>
      </div>
    </div>
    
    <div class="row"  *ngIf="appName != 'avafitogest'">
      <h4 class="col-sm">ACTUACIÓN RASTROJO</h4>
      <div class="mb-5 col-sm-12">
        <app-form-builder
          [model]="model"
          [distributionColumns]="3"
          [fields]="formFieldsRastrojo"
          (formChanges)="formChanges($event)">
        </app-form-builder>
      </div>
    </div>
    
    <div class="d-flex justify-content-center">
      <div>
        <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
      </div>
      <app-request-button
              (click)="submit()"
              [lockOnSuccess]="true"
              [mode]="requestButtonType"
              [request]="request">
      </app-request-button>
    </div>
  </p-panel>

  
  <app-upload-file [showUploadDialog]="showDialogUploadFile"  [options]="optionsUploadFile" (eventClose)="showDialogUploadFile = false" (eventUpload)="handleEventUpload($event)"></app-upload-file>